import { useState, useEffect, useRef } from "react";

import { useLocation } from "react-router-dom";

import { PROFILE_UI_CONTENT } from "./profileContextContent";
import { resolveProfileUIText } from "./resolveProfileUIText";

import {
  getEducationList,
  getProfessionList,
  getIncomeList,
  submitEducationProfessionIncome,
  getCountryList,
  getStateList,
  getCityList,
  submitLivingIn,
} from "../../javaAxiosConfig";

import RegistrationStepLayout from "./RegistrationStepLayout";

// icons (use your real icons)
import searchIcon from "../../images/searchIcon.svg";
import upArrow from "../../images/updropArrow.png";
import downArrow from "../../images/downdropArrow.png";

import infoIcon from "../../images/i-buton.png";

import EducationIcon from "../../images/educationIconW.png";
import ProfessionIcon from "../../images/professionIcon.png";
import LocationIcon from "../../images/livingIcon.png";

/* =====================================================
   PARENT – EDUCATION & PROFESSION FLOW
===================================================== */

// const EDUCATION_PROGRESS_KEY = "education_sub_step";

// const EDUCATION_SUBSTEP_FROM_PROGRESS = {
//   EDUCATION_PROFESSION_INCOME_CHECK: 1, // Living In
// };

const EducationProfessionFlow = ({ onCompleted, isFresh }) => {
  const [step, setStep] = useState(1);

  const [slideClass, setSlideClass] = useState("");
const prevStepRef = useRef(step)


useEffect(() => {
  if (isFresh) return;

  const progress = localStorage.getItem("registrationProgress");

  console.log("[EDU FLOW] progress check:", progress);

  if (progress === "EDUCATION_PROFESSION_INCOME_CHECK") {
    setStep(3); // go to Living In
  } else {
    setStep(1);
  }
}, []);


// useEffect(() => {
//   if (isFresh) return;

//   const progress = localStorage.getItem("registrationProgress");

//   console.log("[EDU FLOW] progress check:", progress);

//   // Only auto-jump if backend says this step already completed
//   if (progress === "EDUCATION_PROFESSION_INCOME_CHECK") {
//     setStep(3); // go to Living In
//   } else {
//     setStep(1);
//   }
// }, []);



  const [educationData, setEducationData] = useState({
    educationId: null,
    educationDescription: "",
    occupationId: null,
    occupationDescription: "",
    incomeId: null,
  });

  useEffect(() => {
  if (prevStepRef.current === step) return;

  const isForward = step > prevStepRef.current;

  setSlideClass(isForward ? "slide-forward" : "slide-backward");

  const timer = setTimeout(() => {
    setSlideClass("");
  }, 500);

  prevStepRef.current = step;

  return () => clearTimeout(timer);
}, [step]);


const next = () => {
  setStep((s) => s + 1);
};

  // const next = () => {
  //   setStep((s) => {
  //     const n = s + 1;
  //     localStorage.setItem(EDUCATION_PROGRESS_KEY, n);
  //     return n;
  //   });
  // };

  const back = () => setStep((s) => Math.max(1, s - 1));

  const EDUCATION_STEP_KEYS = {
    EDUCATION: "EDUCATION",
    PROFESSION: "PROFESSION",
    LIVING_IN: "LIVING_IN",
  };

  const profileCreatedById = Number(localStorage.getItem("profileCreatedById"));
  const gender = localStorage.getItem("selectedGender");

  const getResolvedEduText = (stepKey) => {
    const stepConfig = PROFILE_UI_CONTENT?.[stepKey];
    if (!stepConfig) return { title: "", subtitle: "" };

    return resolveProfileUIText({
      profileCreatedById,
      gender,
      stepKey,
      stepConfig,
    });
  };

  return (
    <>

    <div className={`registration-anim-wrapper ${slideClass}`}>
      {step === 1 &&
        (() => {
          const resolved = getResolvedEduText("EDUCATION");

          return (
            <EducationStep
              title={resolved.title} // ✅ ADD THIS
              subtitle={resolved.subtitle}
              onNext={(data) => {
                setEducationData((p) => ({
                  ...p,
                  educationId: data.educationId,
                  educationDescription: data.educationDescription,
                }));
                next();
              }}
            />
          );
        })()}

      {step === 2 &&
        (() => {
          const resolved = getResolvedEduText("PROFESSION");

          return (
            <ProfessionStep
              title={resolved.title}
              subtitle={resolved.subtitle}
              onBack={back}
              onNext={async (data) => {
                const payload = {
                  ...educationData,
                  occupationId: data.occupationId,
                  occupationDescription: data.occupationDescription,
                  incomeId: data.incomeId,
                };

                await submitEducationProfessionIncome(payload);
                next();
              }}
            />
          );
        })()}

      {/* {step === 3 && (
  <LivingInStep
    onBack={back}
    onCompleted={onCompleted}
  />
)} */}

      {step === 3 &&
        (() => {
          const resolved = getResolvedEduText("LIVING_IN");

          return (
            <LivingInStep
              title={resolved.title}
              subtitle={resolved.subtitle}
              onBack={back}
              onCompleted={onCompleted}
            />
          );
        })()}

        </div>
    </>
  );
};

export default EducationProfessionFlow;

const inputBoxStyle = {
  height: 50,
  width: "100%",
  borderRadius: 12,
  border: "1px solid #e8e6ea",
  display: "flex",
  alignItems: "center",
  padding: "0 16px",
  marginBottom: 20,
  color: "#777",
};

const textareaStyle = {
  width: "100%",
  height: 100,
  borderRadius: 12,
  border: "1px solid #e8e6ea",
  padding: 16,
  resize: "none",
  marginTop: 30,
};

const errorTextStyle = {
  color: "#ff3c3c",
  fontSize: "12px",
  marginTop: "6px",
  fontFamily: "Montserrat",
};

const infoBoxStyle = {
  marginTop: 20,
  padding: 14,
  border: "1px dashed rgba(230,0,0,0.5)",
  borderRadius: 12,
  fontSize: 12,
  color: "#555",
  textAlign: "center",
  justifyContent: "center",
};

const SkipButton = ({ onClick }) => (
  <div
    onClick={onClick}
    style={{
      marginTop: 80,
      height: 50,
      width: "100%",
      borderRadius: 50,
      border: "1px solid rgba(230,0,0,0.81)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "rgba(230,0,0,0.81)",
      fontWeight: 600,
      cursor: "pointer",
    }}
  >
    Skip for now
  </div>
);

/* =====================================================
   common dorpdown and input ui
===================================================== */

const DropdownInput = ({ label, open, onClick }) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation(); // 🔥 IMPORTANT
        onClick();
      }}
      style={{
        marginTop: 30,
        width: "100%",
        height: 57,
        borderRadius: 13,
        border: "1px solid #e8e6ea",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px",
        cursor: "pointer",
        fontWeight: 500,
        color: "rgba(0,0,0,0.7)",
      }}
    >
      {label}
      <img src={open ? upArrow : downArrow} alt="" width={18} />
    </div>
  );
};

const DropdownOverlay = ({
  data,
  labelKey,
  onClose,
  onSelect,
  topOffset = 80,
}) => {
  const ref = useRef();
  const [search, setSearch] = useState("");

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  //   const filteredData = data.filter((item) =>
  //     item[labelKey].toLowerCase().includes(search.toLowerCase())
  //   );

  const filteredData = (data || []).filter(
    (item) =>
      item[labelKey] &&
      item[labelKey].toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div
      ref={ref}
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "absolute",
        // top: 80,
        top: topOffset,
        left: 0,
        width: "100%",
        maxWidth: 500,
        height: 280,
        borderRadius: 15,
        background: "#fffcfb",
        border: "1px solid #e8e6ea",
        animation: "fadeIn 0.2s ease",

        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        zIndex: 10,
      }}
    >
      {/* SEARCH */}
      <div
        style={{
          margin: 15,
          height: 43,
          borderRadius: 50,
          border: "1px solid #eee",
          display: "flex",
          alignItems: "center",
          padding: "0 12px",
          gap: 10,
          boxShadow: "0px 4px 12px rgba(13,10,44,0.06)",
        }}
      >
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search ..."
          style={{
            flex: 1,
            border: "none",
            outline: "none",
            background: "transparent",
            fontSize: 13,
          }}
        />
        <img src={searchIcon} alt="" width={28} />
      </div>

      {/* LIST */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          paddingBottom: 1,
        }}
      >
        {/* {filteredData.map((item, i) => (
          <div key={i}>
            <div
            //   onClick={() => onSelect(item[labelKey])}
            onClick={() => onSelect(item)}

              style={{
                padding: "14px 45px",
                cursor: "pointer",
                fontWeight: 500,
              }}
            >
              {item[labelKey]}
            </div>

            <div
              style={{
                height: 0.3,
                margin: "0 35px",
                background:
                  "linear-gradient(90deg, rgba(255,119,5,0), rgba(230, 0, 0, 0.53), rgba(255,119,5,0))",
              }}
            />
          </div>
        ))} */}

        {filteredData.map((item, i) => (
          <div key={i}>
            <div
              onClick={() => onSelect(item)}
              style={{
                padding: "14px 45px",
                cursor: "pointer",
                fontWeight: 500,
              }}
            >
              {item[labelKey]}
            </div>

            {/* ✅ Divider only BETWEEN options */}
            {i !== filteredData.length - 1 && (
              <div
                style={{
                  height: 1.2, // slightly safer than 0.3
                  margin: "1px 35px",
                  background:
                    "linear-gradient(90deg, rgba(255,119,5,0), rgba(230, 0, 0, 0.53), rgba(255,119,5,0))",
                }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

/* =====================================================
   STEP 1 – EDUCATION
===================================================== */

const EducationStep = ({ onNext, title, subtitle }) => {
  const [education, setEducation] = useState(null);
  const [showEducation, setShowEducation] = useState(false);
  const [educationList, setEducationList] = useState([]);
  const [about, setAbout] = useState("");

  const [educationError, setEducationError] = useState("");
  const [aboutError, setAboutError] = useState("");

  const validateEducation = () => {
    let valid = true;

    if (!education) {
      setEducationError("Please select your education");
      valid = false;
    } else {
      setEducationError("");
    }

    if (about && (about.length < 5 || about.length > 250)) {
      setAboutError("Description must be between 5 and 250 characters");
      valid = false;
    } else {
      setAboutError("");
    }

    return valid;
  };

  const MIN_DESC = 5;
  const MAX_DESC = 250;

  const isEducationDescValid =
    !about || (about.length >= MIN_DESC && about.length <= MAX_DESC);

  useEffect(() => {
    getEducationList().then((res) => {
      const activeList = (res.data || []).filter((item) => item.isActive === 1);
      setEducationList(activeList);
    });
  }, []);
  return (
    <RegistrationStepLayout
      icon={EducationIcon}
      // title="Your Education"
      // subtitle="Tell Us About your highest Education."

      title={title}
      subtitle={subtitle}
      stepText="Step 1 of 3"
      onContinue={() => {
        let valid = true;

        // 🔴 Required dropdown
        if (!education) {
          setEducationError("Please select your education");
          valid = false;
        } else {
          setEducationError("");
        }

        // 🔴 Optional textarea validation
        if (about && (about.length < 5 || about.length > 250)) {
          setAboutError("Description must be between 5 and 250 characters");
          valid = false;
        } else {
          setAboutError("");
        }

        if (!valid) return;

        onNext({
          educationId: education.id,
          educationDescription: about || "",
        });
      }}
    >
      {/* Education Dropdown */}
      <div style={{ width: "100%" }}>
        {/* EDUCATION DROPDOWN */}
        <div style={{ position: "relative", width: "100%" }}>
          <DropdownInput
            label={education?.education || "Select Education"}
            open={showEducation}
            onClick={() => setShowEducation((p) => !p)}
          />

          {educationError && <div style={errorTextStyle}>{educationError}</div>}

          {showEducation && (
            <DropdownOverlay
              data={educationList}
              labelKey="education" // 👈 backend key
              onClose={() => setShowEducation(false)}
              //   onSelect={(val) => {
              //     setEducation(val);
              //     setShowEducation(false);
              //   }}

              onSelect={(item) => {
                setEducation(item);
                setEducationError("");
                setShowEducation(false);
              }}
            />
          )}
        </div>
      </div>

      {/* About Education */}
      <textarea
        placeholder="Enter Education Description (Optional)"
        value={about}
        // onChange={(e) => setAbout(e.target.value)}
        onChange={(e) => {
          const val = e.target.value;
          setAbout(val);

          // 🔹 Live validation
          if (!val) {
            setAboutError("");
          } else if (val.length < 5 || val.length > 250) {
            setAboutError("Description must be between 5 and 250 characters");
          } else {
            setAboutError("");
          }
        }}
        style={textareaStyle}
      />
      {aboutError && <div style={errorTextStyle}>{aboutError}</div>}

      {/* Skip */}
      {/* <SkipButton onClick={onNext} /> */}
    </RegistrationStepLayout>
  );
};

/* =====================================================
   STEP 2 – PROFESSION & INCOME
===================================================== */

const ProfessionStep = ({ onBack, onNext, title, subtitle }) => {
  //   const [profession, setProfession] = useState("");
  const [profession, setProfession] = useState(null);
  const [about, setAbout] = useState("");
  //   const [income, setIncome] = useState("");
  const [income, setIncome] = useState(null);

  const [showProfession, setShowProfession] = useState(false);
  const [professionList, setProfessionList] = useState([]);

  const [showIncome, setShowIncome] = useState(false);
  const [incomeList, setIncomeList] = useState([]);

  const [professionError, setProfessionError] = useState("");
  const [incomeError, setIncomeError] = useState("");
  const [aboutError, setAboutError] = useState("");

  const validateProfession = () => {
    let valid = true;

    if (!profession) {
      setProfessionError("Please select your profession");
      valid = false;
    } else {
      setProfessionError("");
    }

    if (!income) {
      setIncomeError("Please select your income");
      valid = false;
    } else {
      setIncomeError("");
    }

    if (about && (about.length < 5 || about.length > 250)) {
      setAboutError("Description must be between 5 and 250 characters");
      valid = false;
    } else {
      setAboutError("");
    }

    return valid;
  };

  useEffect(() => {
    getProfessionList().then((res) => {
      const activeList = (res.data || []).filter((item) => item.isActive === 1);
      setProfessionList(activeList);
    });
  }, []);

  useEffect(() => {
    getIncomeList().then((res) => {
      const activeList = (res.data || []).filter((item) => item.isActive === 1);
      setIncomeList(activeList);
    });
  }, []);

  return (
    <RegistrationStepLayout
      icon={ProfessionIcon}
      // title="Your Profession"
      // subtitle="Tell Us About Your Profession."

      title={title}
      subtitle={subtitle}
      stepText="Step 2 of 3"
      onBack={onBack}
      onContinue={() => {
        let valid = true;

        if (!profession) {
          setProfessionError("Please select your profession");
          valid = false;
        } else {
          setProfessionError("");
        }

        if (!income) {
          setIncomeError("Please select your income");
          valid = false;
        } else {
          setIncomeError("");
        }

        if (about && (about.length < 5 || about.length > 250)) {
          setAboutError("Description must be between 5 and 250 characters");
          valid = false;
        } else {
          setAboutError("");
        }

        if (!valid) return;

        onNext({
          occupationId: profession.id,
          occupationDescription: about || "",
          incomeId: income.id,
        });
      }}
    >
      <div style={{ position: "relative", width: "100%" }}>
        <DropdownInput
          label={profession?.occupation || "Select Profession"}
          open={showProfession}
          onClick={() => setShowProfession((p) => !p)}
        />

        {professionError && <div style={errorTextStyle}>{professionError}</div>}

        {showProfession && (
          <DropdownOverlay
            data={professionList}
            topOffset={110}
            labelKey="occupation"
            onClose={() => setShowProfession(false)}
            onSelect={(item) => {
              setProfession(item);
              setProfessionError("");
              setShowProfession(false);
            }}
          />
        )}
      </div>

      <textarea
        placeholder="Enter Profession Description (Optional)"
        value={about}
        // onChange={(e) => setAbout(e.target.value)}
        onChange={(e) => {
          const val = e.target.value;
          setAbout(val);

          // 🔹 Live validation
          if (!val) {
            setAboutError("");
          } else if (val.length < 5 || val.length > 250) {
            setAboutError("Description must be between 5 and 250 characters");
          } else {
            setAboutError("");
          }
        }}
        style={textareaStyle}
      />

      {aboutError && <div style={errorTextStyle}>{aboutError}</div>}

      <div style={{ position: "relative", width: "100%" }}>
        <DropdownInput
          label={income?.incomeType || "Select Income (LPA)"}
          open={showIncome}
          onClick={() => setShowIncome((p) => !p)}
        />

        {incomeError && <div style={errorTextStyle}>{incomeError}</div>}

        {showIncome && (
          <DropdownOverlay
            data={incomeList}
            topOffset={-110}
            labelKey="incomeType"
            onClose={() => setShowIncome(false)}
            onSelect={(item) => {
              setIncome(item);
              setIncomeError("");
              setShowIncome(false);
            }}
          />
        )}
      </div>
    </RegistrationStepLayout>
  );
};

/* =====================================================
   STEP 3 – LIVING IN
===================================================== */

const LivingInStep = ({ onBack, onCompleted, title, subtitle }) => {
  const [country, setCountry] = useState(null);
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [showCountry, setShowCountry] = useState(false);
  const [showState, setShowState] = useState(false);
  const [showCity, setShowCity] = useState(false);

  const [countryError, setCountryError] = useState("");
  const [stateError, setStateError] = useState("");
  const [cityError, setCityError] = useState("");

  //   useEffect(() => {
  //     getCountryList().then(res =>
  //       setCountries((res.data || []).filter(i => i.isActive))
  //     );
  //   }, []);

  useEffect(() => {
    getCountryList().then((res) => {
      const activeCountries = (res.data || []).filter((i) => i.isActive);
      setCountries(activeCountries);

      // ✅ PRESELECT INDIA (id = 233)
      const india = activeCountries.find((c) => c.id === 233);
      if (india) {
        setCountry(india);
        setCountryError(""); // clear validation if any
      }
    });
  }, []);

  useEffect(() => {
    if (!country) return;

    getStateList(country.id)
      .then((res) => {
        setStates((res.data || []).filter((i) => i.isActive));
      })
      .catch(() => {
        // ✅ No states available for this country
        setStates([]);
      });
  }, [country]);

  useEffect(() => {
    if (!state) return;
    //   getCityList(state.id).then(res =>
    //     setCities((res.data || []).filter(i => i.isActive))
    //   );
    // }

    getCityList(state.id)
      .then((res) => {
        setCities((res.data || []).filter((i) => i.isActive));
      })
      .catch(() => {
        // ✅ No cities available
        setCities([]);
      });
  }, [state]);

  return (
    <RegistrationStepLayout
      icon={LocationIcon}
      // title="Living In"
      // subtitle="Please provide your present residential address."

      title={title}
      subtitle={subtitle}
      stepText="Step 3 of 3"
      //   onBack={onBack}

      onContinue={async () => {
        let valid = true;

        if (!country) {
          setCountryError("Please select country");
          valid = false;
        }

        if (!state) {
          setStateError("Please select state");
          valid = false;
        }

        if (!city) {
          setCityError("Please select city");
          valid = false;
        }

        if (!valid) return;

        await submitLivingIn({
          countryId: country.id,
          stateId: state.id,
          cityId: city.id,
        });

        // localStorage.setItem("registrationProgress", "NATIVE_ADDRESS_CHECK");

        onCompleted();
      }}
      continueVariant="button"
    >
      <div style={{ position: "relative", width: "100%" }}>
        <DropdownInput
          label={country?.country || "Select Country"}
          open={showCountry}
          onClick={() => {
            setShowCountry((p) => !p);
            //   setShowCountry(true);
            setShowState(false);
            setShowCity(false);
          }}
        />

        {countryError && <div style={errorTextStyle}>{countryError}</div>}

        {showCountry && (
          <DropdownOverlay
            data={countries}
            topOffset={96}
            labelKey="country"
            onClose={() => setShowCountry(false)}
            onSelect={(item) => {
              setCountry(item);
              setCountryError("");
              setState(null);
              setCity(null);
              setStateError("");
              setCityError("");
              //   setShowCountry(false);
              setShowCountry(false);
              setShowState(false);
              setShowCity(false);
            }}
          />
        )}
      </div>

      <div style={{ position: "relative", width: "100%" }}>
        <DropdownInput
          label={state?.state || "Select State"}
          open={showState}
          onClick={() => {
            setShowState((p) => !p);
            //   setShowState(true);
            setShowCountry(false);
            setShowCity(false);
          }}
        />

        {stateError && <div style={errorTextStyle}>{stateError}</div>}

        {showState && (
          <DropdownOverlay
            data={states}
            topOffset={90}
            labelKey="state"
            onClose={() => setShowState(false)}
            onSelect={(item) => {
              setState(item);
              setStateError("");
              setCity(null);
              setCityError("");
              //   setShowState(false);
              setShowState(false);
              setShowCity(false);
            }}
          />
        )}
      </div>

      <div style={{ position: "relative", width: "100%" }}>
        <DropdownInput
          label={city?.city || "Select City"}
          open={showCity}
          onClick={() => {
            setShowCity((p) => !p);
            //  setShowCity(true);
            setShowCountry(false);
            setShowState(false);
          }}
        />

        {cityError && <div style={errorTextStyle}>{cityError}</div>}

        {showCity && (
          <DropdownOverlay
            data={cities}
            topOffset={2}
            labelKey="city"
            onClose={() => setShowCity(false)}
            onSelect={(item) => {
              setCity(item);
              setCityError("");
              setShowCity(false);
            }}
          />
        )}
      </div>

      <div
        style={{
          ...infoBoxStyle,
          display: "flex",
          alignItems: "flex-start",
          gap: 12,
          width: "100%",
        }}
      >
        <img
          src={infoIcon}
          alt="info"
          style={{
            width: 22,
            height: 22,
            flexShrink: 0,
            marginTop: 0,
          }}
        />

        <span style={{ lineHeight: "1.98", textAlign: "left" }}>
          You may change or update this information anytime later from your
          profile settings.{" "}
        </span>
      </div>
    </RegistrationStepLayout>
  );
};
